import { all, call } from 'redux-saga/effects';

import dnsSagas from './dns/dnsSagas';
import firewallSagas from './firewall/firewallSagas';

export default function* sagas() {
	yield all([call(firewallSagas), call(dnsSagas)]);
}
